import { useState } from "react";
import { getAllErrorsAsString, ServicesURL } from "@utils/utilsApi";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import { Association } from "src/interfaces/Common";
import { PagesID } from "@utils/utilsConfigurations";

export const useAddEditCategorizationsProject = (
  triggerCategorization: (input: any) => any,
  mutate?: any,
  dataDetail?: any,
  dataProject?: any,
) => {
  const [openConfirmStatus, setOpenConfirmStatus] = useState<{
    s: StatusEnum;
    message?: string;
  }>();
  const [openAssociations, setOpenAssociations] = useState<
    boolean | Association
  >(false);
  const [accountsAssociation, setAccountsAssociation] = useState<any>([]);

  const [savedInputForm, setSavedInputForm] = useState(null);
  const [savedDetails, setsavedDetails] = useState<any[]>([]);

  const resetDetailAssociations = () => {
    setAccountsAssociation([]);
  };

  const setOpenAssociation = (
    accessorKey: string,
    value: boolean,
    detailForm: any,
  ) => {
    switch (accessorKey) {
      case "account":
        let cdc = dataProject?.cost_center_id;
        setOpenAssociations(
          value
            ? {
                accessorKey: "account",
                mediaType: "account",
                type: "table",
                titleKey: "account-association",
                pageId: PagesID["accounts"],
                service: `${ServicesURL.getBankAccounts}?cost_centers=${cdc}`,
                multiChoice: false,
              }
            : value,
        );
        break;
    }
  };

  const getValues = (accessorKey: string) => {
    switch (accessorKey) {
      case "account":
        return accountsAssociation;
    }
  };

  const handleDelete = (accessorKey: string, e: any) => {
    switch (accessorKey) {
      case "account":
        setAccountsAssociation(
          accountsAssociation.filter((element: any) => element.id !== e.id),
        );
        break;
    }
  };

  const handleAssociation = (accessorKey: string, value: any) => {
    switch (accessorKey) {
      case "account":
        const objToAccountsAssociation: any = Object.keys(value).map(
          (key: string) => {
            if (key.includes("||")) {
              return {
                id: key.split("||")[0],
                label: key.split("||")[1],
              };
            } else {
              return accountsAssociation.find((elem: any) => elem.id === +key);
            }
          },
        );
        setAccountsAssociation(objToAccountsAssociation);
        break;
    }
  };

  const onSubmit = async (inputForm: any, details: any) => {
    let newInputForm = {
      allocated_budget: Number(inputForm.allocated_budget) || null,
      categorizations: details.map((detail: any) => {
        return {
          id: Number(detail.id) || null,
          macro_category_id: detail.macro_category.length
            ? Number(detail.macro_category[0].id)
            : detail.macro_category.id,
          allocated_budget: Number(detail.allocated_budget) || null,
        };
      }),
    };

    setSavedInputForm(null);
    setsavedDetails([]);
    setOpenConfirmStatus({ s: StatusEnum.LOADING });

    try {
      await triggerCategorization(newInputForm);
      setOpenConfirmStatus({ s: StatusEnum.OK });
    } catch (error) {
      setOpenConfirmStatus({
        s: StatusEnum.KO,
        message: getAllErrorsAsString(error),
      });
    }
    mutate && mutate(inputForm);
  };

  return {
    onSubmit,
    setOpenConfirmStatus,
    openConfirmStatus,
    handleAssociation,
    setOpenAssociation,
    handleDelete,
    getValues,
    resetDetailAssociations,
    openAssociations,
    setAccountsAssociation,
    accountsAssociation,
  };
};
